<h1 class="page-title">Tartalmak</h1>

<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/tartalmak/hirek']">Hírek</a></p>
<!--<p><i class="fa fa-arrow-right"></i> <a [routerLink]="['/tartalmak/naptar']">Naptár</a></p>-->



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/contents/contents/contents.component.html